import React from "react";
import { useState, useEffect } from "react";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import { Form, Formik } from "formik";
import { FollowersInfo } from "../../SchemaInfo/info";
import { FollowersSchema } from "../../Schemas/Followers Update/follower_schema";
import Footer from "../../Components/Footer/footer";
import CustomInput from "../../CustomComponent/custom_input";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router";
import { Toast } from "../../CustomComponent/toast";
// import { useParams } from "react-router";

const AddFollowers = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [followers, setFollowers] = useState(FollowersInfo);

  useEffect(() => {
    performRequest("GET", `/followers/get-followers/${1}`)
      .then((res) => {
        if (res.status === 200) {
          setFollowers(res.data);
        } else {
          Toast("error", "Error while getting Followers !");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleSubmit = (values, actions) => {
    setLoading(true);
    performRequest("PATCH", `/followers/update-followers/${1}`, values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Followers updated successfully!");
          navigate("/i-dashboard");
        } else {
          Toast("error", "Error while updating followers");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

    

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center"></div>
            </div>
            <div className="card my-4">
              <div className="ps-3 pt-3">
                <h1
                  className="text-center"
                  style={{
                    color: "rgb(131, 129, 69)",
                    fontWeight: "700",
                    fontSize: "30px",
                  }}
                >
                  UPDATE FOLLOWERS
                </h1>
              </div>
              <hr></hr>
              <Formik
                initialValues={followers}
                validationSchema={FollowersSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Instagram Followers :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="instagram" type="text" />
                          {props.touched.instagram &&
                            props.errors.instagram && (
                              <p className="text-danger">
                                {props.errors.instagram}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Facebook Followers :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="facebook" type="text" />
                          {props.touched.facebook && props.errors.facebook && (
                            <p className="text-danger">
                              {props.errors.facebook}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Linkedin Connections :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="linkedin" type="text" />
                          {props.touched.linkedin && props.errors.linkedin && (
                            <p className="text-danger">
                              {props.errors.linkedin}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Youtube Subscribers :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="youtube" type="text" />
                          {props.touched.youtube && props.errors.youtube && (
                            <p className="text-danger">
                              {props.errors.youtube}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Google Ratings :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="google" type="text" />
                          {props.touched.google && props.errors.google && (
                            <p className="text-danger">{props.errors.google}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton
                          buttonText="Submit Feedback"
                          className="btn btn-success"
                        />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AddFollowers;
